// shuffle Array method
export const shuffleArray = (array) => {
  var currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
};


export const organizeBanners = (banners, currentLanguage) => banners.filter(i => i.language === currentLanguage && i.status && i.status ==='active').sort((a, b) => (a.order > b.order) ? 1 : -1)


export const fillArray = (length, indicator)=> Array(length - (length - indicator)).fill('').map((v, idx) => length - idx)